module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("A S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERIES OF ")]), _vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VERALL ")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERSPECTIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("Contrary to assumptions sometimes made in the social sciences, there is no such thing as a straightforward synchronic cross section, springing unproblematically into view the moment one’s argument requires it. A single snapshot, outside time, without a degree of chronological depth, would be lacking in life and therefore in usefulness. If I present a series of perspectives, as I intend to, from about 1450, 1500, 1550, 1600, and 1650, it is not with the idea that on each occasion I shall be able to give a precise picture of the “situation” immediately discernible at these precise dates. Rather it is to assume a convenient set of vantage points from which to look both forward and backward, according to the disposition of time, the landscapes, and the realities before our eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("How can one gauge or comprehend life in progress without enlisting the passage of time as an accomplice?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c60be78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/outofitaly_00003.vue
// module id = 75
// module chunks = 0